import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import MechanicDashboard from "../views/Dashboard/MechanicDashboard";
import VehicleDetails from "../views/Company/VehicleDetails.js";
import InspectionReportView from "../views/Company/InspectionReportView.js";
import workorder from "../views/Defects/workorder.jsx";
import InspectionDetail from "../inspection/inspectionDetails";
import InspectionList from "../inspection/inspectionList";
import MechanicWork from "../views/Dashboard/MechanicWork";

class MechanicRoutes extends Component {
  render() {
    let { history } = this.props;
    return (
      <Switch>
        <Route exact path="/mech" component={MechanicDashboard} />
        <Route exact path="/mech/customer/:cId" component={MechanicWork} />
        <Route
          exact
          path="/mech/customer/:cId/vehicle/:vId"
          component={VehicleDetails}
        />
        <Route
          exact
          path="/mech/customer/:cId/vehicle/inspection/:iId"
          component={InspectionReportView}
        />
        <Route
          exact
          path="/mech/customer/:cId/defects/work/order/:dId"
          component={workorder}
        />
        <Route
          exact
          path="/mech/customer/:cId/inspection/new/details/:id"
          history={history}
          component={InspectionDetail}
        />
        <Route
          exact
          path="/mech/customer/:cId/inspection/new/start/inspection/:id/:type"
          history={history}
          component={InspectionList}
        />
      </Switch>
    );
  }
}

export default MechanicRoutes;



// WEBPACK FOOTER //
// ./src/vendors/MechanicRoutes.js